export default {
  id: null,
  email: '',
  password: '',
  rol: '',
};
